import * as React from 'react';

// Official Meta brand glyph — blue rounded square with the white "f".
// Colors from https://about.meta.com/brand/resources/facebookapp/logo/
export default ({ viewBox, style }) => (
  <svg width="40" height="40" viewBox={viewBox} style={style}>
    <rect width="40" height="40" rx="8" fill="#1877F2" />
    <path
      d="M26.4 25.78l.887-5.78h-5.545v-3.75c0-1.58.774-3.122 3.257-3.122H27.5V8.39S25.23 8 23.058 8c-4.535 0-7.5 2.748-7.5 7.725V20h-5.075v5.78h5.075V39.75c1.018.16 2.061.25 3.125.25 1.064 0 2.107-.09 3.125-.25V25.78h4.592z"
      fill="#FFF"
    />
  </svg>
);
